/** Shared display helpers for timestamps and API error payloads. */

const UNITS: [Intl.RelativeTimeFormatUnit, number][] = [
  ["year", 365 * 24 * 3600],
  ["month", 30 * 24 * 3600],
  ["week", 7 * 24 * 3600],
  ["day", 24 * 3600],
  ["hour", 3600],
  ["minute", 60],
];

const relative = new Intl.RelativeTimeFormat("en-US", { numeric: "auto" });

/** "3 hours ago" style label for an ISO timestamp. */
export function timeAgo(iso: string | null | undefined): string {
  if (!iso) {
    return "";
  }
  const seconds = (new Date(iso).getTime() - Date.now()) / 1000;
  if (Number.isNaN(seconds)) {
    return "";
  }
  for (const [unit, size] of UNITS) {
    if (Math.abs(seconds) >= size) {
      return relative.format(Math.round(seconds / size), unit);
    }
  }
  return "just now";
}

/** Short date-time label, e.g. "Oct 16, 2026, 2:05 PM". */
export function formatDateTime(iso: string | null | undefined): string {
  if (!iso) {
    return "";
  }
  const date = new Date(iso);
  return Number.isNaN(date.getTime())
    ? iso
    : date.toLocaleString("en-US", { dateStyle: "medium", timeStyle: "short" });
}

/** HTTP status of an `ApiError` thrown by the SDK, if any. */
export function errorStatus(err: unknown): number | undefined {
  return (err as { status?: number } | null | undefined)?.status;
}

/** FastAPI `detail` message of an `ApiError`, when it is a plain string. */
export function errorDetail(err: unknown): string | undefined {
  const detail = (err as { body?: { detail?: unknown } } | null | undefined)?.body?.detail;
  return typeof detail === "string" ? detail : undefined;
}
